module.exports = __webpack_public_path__ + "img/12_klio_05.764ec6b8.jpg";